// extracted by mini-css-extract-plugin
export default {"contactPageContainer":"Contact_contactPageContainer_wnKDk","emailLink":"Contact_emailLink_r5QBh"};